import React, { useMemo, useState } from 'react';
import { Collapse } from 'react-collapse';
import { useTheme } from '../../../../../../context/themeContext';
import { useDispatch } from 'react-redux';
import { useTranslate } from '../../../../../../context/languageContext';
import { R } from '../../../../../../R';
import { useSelector } from 'react-redux';
import { markersInformation } from '../../../../../../../redux/slices/markersSlice';
import { IStopAccess } from '../../../../../../../types/ExploreIntefaces';

export default function AccessStopList({ stopId, accessSelected, setAccessSelected }: { stopId: number, accessSelected: IStopAccess | null, setAccessSelected: Function }) {
  const [opened, setOpened] = useState(false);
  const theme = useTheme();
  const ArrowUp = R.drawables.general.Ic_arrowup;
  const ArrowDown = R.drawables.general.Ic_arrowdown;
  const WheelChair = R.drawables.general.Ic_silladeruedas;
  const escalator = require('../../../../../../../res/values/drawables/general/Ic_escalator.png'); /* R.drawables.general.Ic_escalator */
  const dispatch = useDispatch();

  const allAccesses = useSelector(markersInformation).accesses;
  const accessesOfStation: Array<IStopAccess> = useMemo(() => {
    return allAccesses.filter((element: IStopAccess) => element.stopParentId === stopId);
  }, [stopId, allAccesses]);

  const t = useTranslate();

  function renderAccesses(stopAccess: IStopAccess) {
    return (
      <div
        key={`access-${stopAccess.id}`}
        onClick={() => {
          setAccessSelected(stopAccess);
        }}
        style={{
          flexDirection: 'row',
          textAlign: 'left',
          display: 'flex',
          alignItems: 'center',
          columnGap: 8,
          paddingBottom: 12, 
          cursor: 'pointer',
        }}>
        {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}> */}
          <img src={escalator} style={{ width: 36, height: 36 }} />
          {/* {stopAccess?.wheelchairBoarding ? (
            <WheelChair style={{ fill: 'black', height: 20, width: 20 }} />
          ) : null}
        </div> */}

        <div style={{ display: 'flex', flexDirection: 'column', width: 292 }}>
          <div style={{ display: 'flex', flexDirection: 'row', columnGap: 8 }}>
            <div
              style={{...{
                fontSize: 14,
                marginTop: 4,
                textAlign: 'left',
                fontWeight: 'bold',
                wordBreak: 'break-word'
              }, ...accessSelected?.id === stopAccess.id ? {color: 'rgb(0, 88, 145)'} : {}}}>
              {`${stopAccess?.name}`}
            </div>
            {stopAccess?.wheelchairBoarding ? (
            <WheelChair style={{ fill: 'black', height: 20, width: 20 }} />
          ) : null}
          </div>

          <div
            style={{
              fontSize: 13,
              fontWeight: 500,
              color: 'rgb(96, 96, 96)',
              wordBreak: 'break-word'
            }}>
            {stopAccess?.desc}
          </div>
        </div>
      </div>
    );
  }

  return accessesOfStation?.length ? (
    <>
      <div
        onClick={() => setOpened(!opened)}
        style={{
          backgroundColor: theme.colors.neutralBackground,
          padding: 8,
          borderRadius: 4,
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          color: theme.colors.neutralDarkGray,
          fontSize: 14,
          fontWeight: 600,
          marginBottom: 8
        }}>
        {t('visualizer_stop_accesses')}
        {opened ? (
          <ArrowDown style={{ fill: theme.colors.neutralDarkGray, width: 20, height: 20 }} />
        ) : (
          <ArrowUp style={{ fill: theme.colors.neutralDarkGray, width: 20, height: 20 }} />
        )}
      </div>
      <div className={'dropdown-content'}>
        <Collapse isOpened={opened}>
          {<>{accessesOfStation.map((stop) => renderAccesses(stop))}</>}
        </Collapse>
      </div>
    </>
  ) : null;
}
